import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/calmar-ratio-calculator',
  component: () => import('../../routes/CalmarRatioCalculator.svelte'),
  card: {
    id: 'calmar-ratio-calculator',
    title: 'Calmar Ratio Calculator',
    description:
      'Measure risk-adjusted returns using the Calmar Ratio — average return divided by maximum drawdown.',
    icon: 'trending_down',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/calmar-ratio-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Calmar Ratio Calculator — Risk-Adjusted Return Metric',
    description:
      'Calculate the Calmar Ratio to evaluate risk-adjusted investment returns. Compare average annual return against maximum drawdown to assess capital preservation.',
  },
};

export default meta;
